import { render, staticRenderFns } from "./GoodslistBody.vue?vue&type=template&id=6e827032&scoped=true"
import script from "./GoodslistBody.vue?vue&type=script&lang=js"
export * from "./GoodslistBody.vue?vue&type=script&lang=js"
import style0 from "./GoodslistBody.vue?vue&type=style&index=0&id=6e827032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e827032",
  null
  
)

export default component.exports